import { LAYERS } from '../viewer/layers';
import { REGIONS, STRUCTURES } from '../state/structures';
import * as st from '../state/store';
import { track } from '../analytics';

/** Non-3D, keyboard- and screen-reader-friendly way into every part (F05/F17). */
export function BrowseTree() {
  const visible = STRUCTURES.filter((s) => s.selectable && !(st.classroom.value && !st.showSensitive.value && s.sensitive) && (!s.body || s.body === st.body.value));
  return (
    <nav class="browse" aria-label="All parts by system and region" data-testid="browse-tree">
      <div class="browse-head">
        <h2 class="panel-title">All parts</h2>
        <button type="button" class="btn ghost icon" aria-label="Close list" onClick={() => (st.panel.value = st.selected.value ? 'card' : null)}>×</button>
      </div>
      {LAYERS.filter((l) => visible.some((s) => s.layer === l.id)).map((l) => (
        <details key={l.id}>
          <summary>{l.label}</summary>
          {REGIONS.filter((r) => visible.some((s) => s.layer === l.id && s.region === r.id)).map((r) => (
            <details key={r.id} class="nested">
              <summary>{r.label}</summary>
              <ul>
                {visible
                  .filter((s) => s.layer === l.id && s.region === r.id)
                  .sort((a, b) => a.title.localeCompare(b.title))
                  .map((s) => (
                    <li key={s.id}>
                      <a
                        href={`/s/${s.id}`}
                        data-testid="browse-item"
                        data-id={s.id}
                        onClick={(e) => {
                          e.preventDefault();
                          st.select(s.id);
                          track('card_open', { structure_id: s.id, source: 'browse' });
                        }}
                      >
                        {s.title}
                      </a>
                    </li>
                  ))}
              </ul>
            </details>
          ))}
        </details>
      ))}
    </nav>
  );
}
